import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import LoadingIndicator from 'Components/UI/LoadingIndicator';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { dispatchWizardFinishedRefresh } from 'Hooks/useRefreshEvent';

const styles = () => ({
  root: {},
});

const NoopFinishStep = ({
  className,
  classes,
}) => {
  const { clearModalCollection } = useModalContext();

  useEffect(() => {
    dispatchWizardFinishedRefresh();
    clearModalCollection();
  }, []);
  return (
    <LoadingIndicator
      className={classNames(classes.root, className)}
    />
  );
};

NoopFinishStep.defaultProps = {
  className: '',
};

NoopFinishStep.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NoopFinishStep);
